export * from 'Common/config/product';

/* eslint import/export: 0 */
// Disable rule to override exports without errors
export const TRANSFORM_PRODUCT_IMAGE_BACKGROUND = false;
